import React from "react";

const AdvanceEstimator = () => {
  return (
    <section className="w-full bg-[#D7F3EF] py-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          
          {/* Left Card */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-[#1E293B] mb-6">
              Estimate your advance
            </h3>

            <div className="space-y-4">
              <div>
                <label className="block text-sm text-[#64748B] mb-1">
                  Invoice amount
                </label>
                <input
                  type="text"
                  value="$120,000"
                  readOnly
                  className="w-full border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] bg-white"
                />
              </div>

              <div>
                <label className="block text-sm text-[#64748B] mb-1">
                  Buyer credit tier
                </label>
                <input
                  type="text"
                  value="A (low risk)"
                  readOnly
                  className="w-full border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] bg-white"
                />
              </div>

              <div>
                <label className="block text-sm text-[#64748B] mb-1">
                  Tenor (days)
                </label>
                <input
                  type="text"
                  value="30"
                  readOnly
                  className="w-full border border-[#E2E8F0] rounded-lg px-4 py-3 text-[#0F172A] bg-white"
                />
              </div>

              <button className="mt-6 w-full bg-[#0F766E] hover:bg-[#115E59] text-white font-semibold py-3 rounded-lg transition">
                Recalculate
              </button>
            </div>
          </div>

          {/* Right Card */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-[#1E293B] mb-6">
              Projected results
            </h3>

            <div className="space-y-5">
              <ResultRow label="Advance rate" value="90%" />
              <ResultRow label="Cash today" value="$108,000" bold />
              <ResultRow label="Estimated fee (30d)" value="$1,800 – $2,640" />
              <ResultRow label="Effective monthly cost" value="1.0 – 2.2%" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

const ResultRow = ({ label, value, bold }) => {
  return (
    <div className="flex justify-between items-center border-b border-[#E2E8F0] pb-3">
      <span className="text-sm text-[#64748B]">{label}</span>
      <span
        className={`text-[#0F172A] ${
          bold ? "text-lg font-semibold" : "font-medium"
        }`}
      >
        {value}
      </span>
    </div>
  );
};

export default AdvanceEstimator;
